import axios from 'axios'

export default async function fetchMailingPreview(id: number): Promise<string> {
  const { data } = await axios.get<string>(
    `/api/v1/mailing/sendsay/preview/${id}`
  )
  return data
}
